import React, { useEffect, useState } from 'react';

import './InserirRegistro.css';

import iPosto from '../interfaces/iPosto';

import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const InserirRegistro = ({ setCurrentPage }: { setCurrentPage: Function; }) => {

    const apiUrl = process.env.REACT_APP_API_URL;

    const { bootStrapColor } = useSelector((state: RootState) => state.config);

    const [postosList, setPostosList] = useState<iPosto[]>([]);
    const [searchInput, setSeachInput] = useState({ posto: ``, mes: ``, ano: `` });
    const [searchInputAfterClick, setSeachInputAfterClick] = useState({ posto: ``, mes: ``, ano: `` });
    const [chuvas, setchuvas] = useState({ valor01: ``, valor02: ``, valor03: ``, valor04: ``, valor05: ``, valor06: ``, valor07: ``, valor08: ``, valor09: ``, valor10: ``, valor11: ``, valor12: ``, valor13: ``, valor14: ``, valor15: ``, valor16: ``, valor17: ``, valor18: ``, valor19: ``, valor20: ``, valor21: ``, valor22: ``, valor23: ``, valor24: ``, valor25: ``, valor26: ``, valor27: ``, valor28: ``, valor29: ``, valor30: ``, valor31: `` });

    const { posto, mes, ano } = searchInput;
    const { valor01, valor02, valor03, valor04, valor05, valor06, valor07, valor08, valor09, valor10, valor11, valor12, valor13, valor14, valor15, valor16, valor17, valor18, valor19, valor20, valor21, valor22, valor23, valor24, valor25, valor26, valor27, valor28, valor29, valor30, valor31 } = chuvas;

    const handleSearchInputChanges = (element: any) => {
        setSeachInput({ ...searchInput, [element.target.name]: element.target.value });
    };
    const handleChuvaInputChanges = (element: any) => {
        setchuvas({ ...chuvas, [element.target.name]: element.target.value });
    };

    const isBissexto = () => {
        return ((Number(searchInputAfterClick.ano) % 4 === 0) && (Number(searchInputAfterClick.ano) % 100 !== 0)) || (Number(searchInputAfterClick.ano) % 400 === 0);
    };

    const render29 = () => {
        if (searchInputAfterClick.mes === `02` && !isBissexto()) {
            return false;
        }
        return true;
    };
    const render31 = () => {
        if (
            searchInputAfterClick.mes === '01' ||
            searchInputAfterClick.mes === '03' ||
            searchInputAfterClick.mes === '05' ||
            searchInputAfterClick.mes === '07' ||
            searchInputAfterClick.mes === '08' ||
            searchInputAfterClick.mes === '10' ||
            searchInputAfterClick.mes === '12'
        ) {
            return true;
        }
        return false;
    };

    const submitSearch = async () => {
        setSeachInputAfterClick(searchInput);
        try {
            const response = await fetch(`${apiUrl}/registro/${searchInput.posto}/${searchInput.mes}/${searchInput.ano}`);
            const jsonResponse = await response.json();
            setchuvas(jsonResponse);

        } catch (err: any) {
            console.error(err.message);
        }

    };
    const handleLimpar = () => {
        setchuvas({ valor01: ``, valor02: ``, valor03: ``, valor04: ``, valor05: ``, valor06: ``, valor07: ``, valor08: ``, valor09: ``, valor10: ``, valor11: ``, valor12: ``, valor13: ``, valor14: ``, valor15: ``, valor16: ``, valor17: ``, valor18: ``, valor19: ``, valor20: ``, valor21: ``, valor22: ``, valor23: ``, valor24: ``, valor25: ``, valor26: ``, valor27: ``, valor28: ``, valor29: ``, valor30: ``, valor31: `` });
    };
    const handleZerar = () => {

        setchuvas({
            ...chuvas,
            valor01: chuvas.valor01 === '' ? '0' : chuvas.valor01,
            valor02: chuvas.valor02 === '' ? '0' : chuvas.valor02,
            valor03: chuvas.valor03 === '' ? '0' : chuvas.valor03,
            valor04: chuvas.valor04 === '' ? '0' : chuvas.valor04,
            valor05: chuvas.valor05 === '' ? '0' : chuvas.valor05,
            valor06: chuvas.valor06 === '' ? '0' : chuvas.valor06,
            valor07: chuvas.valor07 === '' ? '0' : chuvas.valor07,
            valor08: chuvas.valor08 === '' ? '0' : chuvas.valor08,
            valor09: chuvas.valor09 === '' ? '0' : chuvas.valor09,
            valor10: chuvas.valor10 === '' ? '0' : chuvas.valor10,
            valor11: chuvas.valor11 === '' ? '0' : chuvas.valor11,
            valor12: chuvas.valor12 === '' ? '0' : chuvas.valor12,
            valor13: chuvas.valor13 === '' ? '0' : chuvas.valor13,
            valor14: chuvas.valor14 === '' ? '0' : chuvas.valor14,
            valor15: chuvas.valor15 === '' ? '0' : chuvas.valor15,
            valor16: chuvas.valor16 === '' ? '0' : chuvas.valor16,
            valor17: chuvas.valor17 === '' ? '0' : chuvas.valor17,
            valor18: chuvas.valor18 === '' ? '0' : chuvas.valor18,
            valor19: chuvas.valor19 === '' ? '0' : chuvas.valor19,
            valor20: chuvas.valor20 === '' ? '0' : chuvas.valor20,
            valor21: chuvas.valor21 === '' ? '0' : chuvas.valor21,
            valor22: chuvas.valor22 === '' ? '0' : chuvas.valor22,
            valor23: chuvas.valor23 === '' ? '0' : chuvas.valor23,
            valor24: chuvas.valor24 === '' ? '0' : chuvas.valor24,
            valor25: chuvas.valor25 === '' ? '0' : chuvas.valor25,
            valor26: chuvas.valor26 === '' ? '0' : chuvas.valor26,
            valor27: chuvas.valor27 === '' ? '0' : chuvas.valor27,
            valor28: chuvas.valor28 === '' ? '0' : chuvas.valor28,
            valor29: chuvas.valor29 === '' ? '0' : chuvas.valor29,
            valor30: chuvas.valor30 === '' ? '0' : chuvas.valor30,
            valor31: chuvas.valor31 === '' ? '0' : chuvas.valor31
        });
    };

    const handleSalvar = async () => {
        try {
            const body = {
                posto_id: searchInputAfterClick.posto,
                chuvas: chuvas,
                data: `${searchInputAfterClick.ano}-${searchInputAfterClick.mes}-`,
            };
            const res = await fetch(`${apiUrl}/put-registro`,
                {
                    method: "PUT",
                    headers: { "Content-Type": "application/json", token: localStorage.token },
                    body: JSON.stringify(body)
                });
            if (res.status === 200) {
                toast.success("Dado salvo!");
            } else {
                toast.error("Dado não salvo!");
            }
            handleInit();
        } catch (err: any) {
            console.error(err.message);
        }
    };


    const getSomasDasChuvas = () => {
        let soma = 0;
        for (const value of Object.values(chuvas)) {
            const num = Number(value);
            if (!isNaN(num)) {
                soma += num;
            }
        }
        return soma;
    };
    const getDiasComChuva = () => {
        let cont = 0;
        for (const value of Object.values(chuvas)) {
            if (value && value !== '0') {
                cont++;
            }
        }
        return cont;
    };

    const dateFomater = (num: string) => {
        if (num === '01') return 'Janeiro';
        if (num === '02') return 'Fevereiro';
        if (num === '03') return 'Março';
        if (num === '04') return 'Abril';
        if (num === '05') return 'Maio';
        if (num === '06') return 'Junho';
        if (num === '07') return 'Julho';
        if (num === '08') return 'Agosto';
        if (num === '09') return 'Setembro';
        if (num === '10') return 'Outubro';
        if (num === '11') return 'Novembro';
        if (num === '12') return 'Dezembro';
        return num;
    };

    const handleInit = async () => {
        const response = await fetch(`${apiUrl}/all-postos`);
        const jsonResponse = await response.json();
        setPostosList(jsonResponse);
    };

    useEffect(() => {
        handleInit();
        setCurrentPage(window.location.pathname);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="card m-5 css-app-cinza-claro">
                <h5 className="card-header text-center">Inserir registro</h5>
                <div className="card-body">
                    <div className="d-flex">
                        <div className="input-group pe-2">
                            <label className={`input-group-text bg-${bootStrapColor}`} htmlFor="inputGroupSelectPosto">Posto</label>
                            <select className="form-select" id="inputGroupSelectPosto" name='posto' value={posto} onChange={element => handleSearchInputChanges(element)}>
                                <option value=""></option>
                                {postosList.map((posto: iPosto) => <option key={posto.posto_id} value={posto.posto_id}>{posto.posto_nome}</option>)}
                            </select>
                        </div>
                        <div className="input-group ps-2 pe-2 ">
                            <label className={`input-group-text bg-${bootStrapColor}`} htmlFor="inputGroupSelectMes">Mês</label>
                            <select className="form-select" id="inputGroupSelectMes" name='mes' value={mes} onChange={element => handleSearchInputChanges(element)}>
                                <option value=""></option>
                                <option value="01">Janeiro</option>
                                <option value="02">Fevereiro</option>
                                <option value="03">Março</option>
                                <option value="04">Abril</option>
                                <option value="05">Maio</option>
                                <option value="06">Junho</option>
                                <option value="07">Julho</option>
                                <option value="08">Agosto</option>
                                <option value="09">Setembro</option>
                                <option value="10">Outubro</option>
                                <option value="11">Novembro</option>
                                <option value="12">Dezembro</option>
                            </select>
                        </div>
                        <div className="input-group ps-2">
                            <span className={`input-group-text bg-${bootStrapColor}`} id="inputGroup-ano">Ano</span>
                            <input type="number" min={0} className="form-control" aria-label="ano" aria-describedby="inputGroup-ano" name='ano' value={ano} onChange={element => handleSearchInputChanges(element)} />
                        </div>
                    </div>
                </div>
                <button className='btn btn-primary m-3' disabled={!searchInput.posto || !searchInput.ano || Number(searchInput.ano) <= 0 || !searchInput.mes} onClick={submitSearch}>Buscar</button>
            </div>
            {
                searchInputAfterClick.ano && searchInputAfterClick.mes && searchInputAfterClick.posto &&
                <div className="card m-5 mt-5 css-app-cinza-claro">
                    <div className="card-body">
                        <h4 className="display-6 text-center m-2">{dateFomater(searchInputAfterClick.mes)} {searchInputAfterClick.ano}</h4>
                        <div className="d-flex flex-wrap">

                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon01">01</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor01" value={valor01} onChange={element => handleChuvaInputChanges(element)} name="valor01" aria-describedby="basic-addon01" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon02">02</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor02" value={valor02} onChange={element => handleChuvaInputChanges(element)} name="valor02" aria-describedby="basic-addon02" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon03">03</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor03" value={valor03} onChange={element => handleChuvaInputChanges(element)} name="valor03" aria-describedby="basic-addon03" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon04">04</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor04" value={valor04} onChange={element => handleChuvaInputChanges(element)} name="valor04" aria-describedby="basic-addon04" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon05">05</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor05" value={valor05} onChange={element => handleChuvaInputChanges(element)} name="valor05" aria-describedby="basic-addon05" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon06">06</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor06" value={valor06} onChange={element => handleChuvaInputChanges(element)} name="valor06" aria-describedby="basic-addon06" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon07">07</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor07" value={valor07} onChange={element => handleChuvaInputChanges(element)} name="valor07" aria-describedby="basic-addon07" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon08">08</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor08" value={valor08} onChange={element => handleChuvaInputChanges(element)} name="valor08" aria-describedby="basic-addon08" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon09">09</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor09" value={valor09} onChange={element => handleChuvaInputChanges(element)} name="valor09" aria-describedby="basic-addon09" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon10">10</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor10" value={valor10} onChange={element => handleChuvaInputChanges(element)} name="valor10" aria-describedby="basic-addon10" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon11">11</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor11" value={valor11} onChange={element => handleChuvaInputChanges(element)} name="valor11" aria-describedby="basic-addon11" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon12">12</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor12" value={valor12} onChange={element => handleChuvaInputChanges(element)} name="valor12" aria-describedby="basic-addon12" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon13">13</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor13" value={valor13} onChange={element => handleChuvaInputChanges(element)} name="valor13" aria-describedby="basic-addon13" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon14">14</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor14" value={valor14} onChange={element => handleChuvaInputChanges(element)} name="valor14" aria-describedby="basic-addon14" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon15">15</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor15" value={valor15} onChange={element => handleChuvaInputChanges(element)} name="valor15" aria-describedby="basic-addon15" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon16">16</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor16" value={valor16} onChange={element => handleChuvaInputChanges(element)} name="valor16" aria-describedby="basic-addon16" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon17">17</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor17" value={valor17} onChange={element => handleChuvaInputChanges(element)} name="valor17" aria-describedby="basic-addon17" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon18">18</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor18" value={valor18} onChange={element => handleChuvaInputChanges(element)} name="valor18" aria-describedby="basic-addon18" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon19">19</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor19" value={valor19} onChange={element => handleChuvaInputChanges(element)} name="valor19" aria-describedby="basic-addon19" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon20">20</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor20" value={valor20} onChange={element => handleChuvaInputChanges(element)} name="valor20" aria-describedby="basic-addon20" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon21">21</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor21" value={valor21} onChange={element => handleChuvaInputChanges(element)} name="valor21" aria-describedby="basic-addon21" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon22">22</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor22" value={valor22} onChange={element => handleChuvaInputChanges(element)} name="valor22" aria-describedby="basic-addon22" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon23">23</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor23" value={valor23} onChange={element => handleChuvaInputChanges(element)} name="valor23" aria-describedby="basic-addon23" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon24">24</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor24" value={valor24} onChange={element => handleChuvaInputChanges(element)} name="valor24" aria-describedby="basic-addon24" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon25">25</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor25" value={valor25} onChange={element => handleChuvaInputChanges(element)} name="valor25" aria-describedby="basic-addon25" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon26">26</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor26" value={valor26} onChange={element => handleChuvaInputChanges(element)} name="valor26" aria-describedby="basic-addon26" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon27">27</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor27" value={valor27} onChange={element => handleChuvaInputChanges(element)} name="valor27" aria-describedby="basic-addon27" />
                            </div>
                            <div className="input-group m-2 css-inserir-registro-input-group">
                                <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon28">28</span>
                                <input type="number" min={0} max={1000} className="form-control" aria-label="valor28" value={valor28} onChange={element => handleChuvaInputChanges(element)} name="valor28" aria-describedby="basic-addon28" />
                            </div>
                            {
                                render29() &&
                                <div className="input-group m-2 css-inserir-registro-input-group">
                                    <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon29">29</span>
                                    <input type="number" min={0} max={1000} className="form-control" aria-label="valor29" value={valor29} onChange={element => handleChuvaInputChanges(element)} name="valor29" aria-describedby="basic-addon29" />
                                </div>
                            }
                            {
                                searchInputAfterClick.mes !== '02' &&
                                <div className="input-group m-2 css-inserir-registro-input-group">
                                    <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon30">30</span>
                                    <input type="number" min={0} max={1000} className="form-control" aria-label="valor30" value={valor30} onChange={element => handleChuvaInputChanges(element)} name="valor30" aria-describedby="basic-addon30" />
                                </div>
                            }
                            {
                                render31() && searchInputAfterClick.mes !== '02' &&
                                <div className="input-group m-2 css-inserir-registro-input-group">
                                    <span className={`input-group-text bg-${bootStrapColor}`} id="basic-addon31">31</span>
                                    <input type="number" min={0} max={1000} className="form-control" aria-label="valor31" value={valor31} onChange={element => handleChuvaInputChanges(element)} name="valor31" aria-describedby="basic-addon31" />
                                </div>
                            }
                        </div>
                    </div>
                    <div className="d-flex flex-column m-4">
                        <h6>Soma das chuvas: {getSomasDasChuvas()}</h6>
                        <h6>Dias com chuva: {getDiasComChuva()}</h6>
                    </div>
                    <div className="d-flex m-1 align-self-center">
                        <button className='btn btn-secondary m-1' onClick={handleLimpar}>Limpar</button>
                        <button className='btn btn-secondary m-1' onClick={handleZerar}>Zerar</button>
                        <button className='btn btn-success m-1' onClick={handleSalvar}>Salvar</button>
                    </div>
                </div>
            }
        </>
    );
};

export default InserirRegistro;
